import { cn } from './cn';

export type ButtonVariant = 'primary' | 'ghost' | 'default';

/** `true` = plain `.btn`; `'primary'` / `'ghost'` = filled CTA variants (no `.anchor` typography). */
export type ButtonVariantProp = boolean | ButtonVariant;

export function resolveButtonVariant(btn: ButtonVariantProp | undefined): ButtonVariant | null {
  if (!btn) return null;
  if (btn === true) return 'default';
  return btn;
}

export function buttonSurfaceClass(
  btn: ButtonVariantProp | undefined,
  className?: string,
): string {
  const variant = resolveButtonVariant(btn);
  if (!variant) return cn(className);
  return cn(
    'btn',
    variant === 'primary' && 'btn-primary',
    variant === 'ghost' && 'btn-ghost',
    className,
  );
}

/** Link styled as a button — omit `anchor` class so fluid link styles do not override the CTA. */
export function buttonLinkClass(
  btn: ButtonVariantProp | undefined,
  className?: string,
): string {
  const variant = resolveButtonVariant(btn);
  if (!variant) return cn('group', 'anchor', className);
  return cn('group', buttonSurfaceClass(btn, className));
}
